// extracted by mini-css-extract-plugin
module.exports = {"backGround":"Template_backGround__2otqL","backGroundGray":"Template_backGroundGray__17Uox"};